import { render, staticRenderFns } from "./website-age-checker.vue?vue&type=template&id=74422f92&scoped=true&"
import script from "./website-age-checker.vue?vue&type=script&lang=js&"
export * from "./website-age-checker.vue?vue&type=script&lang=js&"
import style0 from "./website-age-checker.vue?vue&type=style&index=0&id=74422f92&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74422f92",
  null
  
)

export default component.exports